import React, { useState } from "react";
import { Form, Dropdown, DropdownButton, InputGroup } from "react-bootstrap";
import { connect, useDispatch } from "react-redux";
import { CHANGE_AVG_ENTRY_PRICE, CHANGE_BASE_ORDER_PRICE_GAP, CHANGE_ENTRY_NUM, CHANGE_EXTRA_ORDER_PRICE_GAP } from "../../../../actions/create-bot-type";
import TutorialPopup from "../../../help/TutorialPopup";
import LeftRightForm from "../modules/LeftRightForm";
import { restrictAlphabets } from "../../../../utils/Utils";
import { toast } from "react-toastify";

const MomentumEntryView = (props) => {
  const { newBot, isEntry,t } = props;
  const priceMovement = newBot.strategy=="Long"?"increase":"decrease";
  const percentageMovement = newBot.strategy=="Long"?"greater":"lesser";
  const baseOrderPriceGap = newBot.basePriceGapMin
  const extraOrderPriceGap = newBot.extraPriceGapMin
  const percentageCheckMsg = `Extra order percentage must be greater than Base Order Percentage`
  const [showEoPercError,setShowEoPercentageError] = useState(false)
  const dispatch = useDispatch();
  const baseOrderPriceGapChanged = (val) => {
    if (val === "") {
      setShowEoPercentageError(false); // Clear error on empty input
      dispatch({
        type: CHANGE_BASE_ORDER_PRICE_GAP,
        payload: val, // Pass empty value
      });
      dispatch({
        type: CHANGE_ENTRY_NUM,
        payload: 0,
      });
      return;
    }
    const numVal = Number(val); // Convert to number for comparison
    if (numVal >= extraOrderPriceGap && extraOrderPriceGap!="") {
      setShowEoPercentageError(true);
    } else {
      setShowEoPercentageError(false);
    }
      dispatch({
        type: CHANGE_BASE_ORDER_PRICE_GAP,
        payload: numVal,
      });
      dispatch({
        type: CHANGE_ENTRY_NUM,
        payload: 1,
      });
  };
  const extraOrderPriceGapChanged = (val) => {
    // Allow empty value
    if (val === "") {
      setShowEoPercentageError(false); // Clear error on empty input
      dispatch({
        type: CHANGE_EXTRA_ORDER_PRICE_GAP,
        payload: val, // Pass empty value
      });
      return;
    }
  
    const numVal = Number(val); // Convert to number for comparison
    if (numVal <= baseOrderPriceGap) {
      setShowEoPercentageError(true);
    } else {
      setShowEoPercentageError(false);
    }
  
    dispatch({
      type: CHANGE_EXTRA_ORDER_PRICE_GAP,
      payload: numVal,
    });
  };
  
  return (
    <>
    <div className="ba-asset-left">
      <h6>
      {/* {t("sell-bot-entry")} */}
      </h6></div>
    
    <LeftRightForm
      left={<h6>
        Enter Base Order
        </h6>}
      right={ <div className="d-flex">
        <label>if price {priceMovement}s by </label>
        <label data-text={'%'} className="dca input-gp-label">
            <Form.Control
                as="input"
                type="number"
                value={baseOrderPriceGap}
                onChange={(e) => {
                  const value = e.target.value;
                  baseOrderPriceGapChanged(value); // Pass the raw value
                }}
                onKeyPress={(e) => {
                  restrictAlphabets(e);
                }}
                className="input-text input-gp-tex dca-subseq-text small"
              ></Form.Control>
        </label>
        <label>from price captured at bot's start time.</label>
        </div>
        }
    >
    </LeftRightForm>
    <LeftRightForm
      left={<h6>
        Enter Extra Order 
        </h6>}
      right={ <div className="d-flex">
        <label>if price continues to {priceMovement} by </label>
        <label data-text={'%'} className="dca input-gp-label">
            <Form.Control
                as="input"
                type="number"
                value={extraOrderPriceGap}
                onChange={(e) => {
                  const value = e.target.value;
                  extraOrderPriceGapChanged(value); // Pass the raw value
                }}
                onKeyPress={(e) => {
                  restrictAlphabets(e);
                }}
                className="input-text input-gp-tex dca-subseq-text small"
              ></Form.Control>
        </label>
        <label>from price captured at bot's start time.</label>
        </div>
        }
    >
    </LeftRightForm>
    {showEoPercError?<label className="danger">{percentageCheckMsg}</label>:<></>}
             
    </>
  );
};

export default connect(null)(MomentumEntryView);
